import { Component, OnDestroy, OnInit } from '@angular/core';
import { SearchmaskComponent } from 'searchmask-lib';
import { AvailabilityService, PIMContactDetailsv2 } from 'core-lib';
import { ShopcartService } from 'core-lib';
import { SettingsService } from 'core-lib';
import { LanguageService } from 'core-lib';
import { IHotelInfo, ISearchParams } from 'core-lib';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { AvailabilityRoom1SkeletonComponent } from "../../components/availability-room-1-skeleton/availability-room-1-skeleton.component";
import { PIMService } from 'core-lib';
import { ButtonModule } from 'primeng/button';
import { ImageGallery1Component } from '../../components/image-gallery1/image-gallery1.component';
import { MapComponent } from "../../components/map/map.component";
import { DialogModule } from 'primeng/dialog';


@Component({
    selector: 'app-hotels',
    imports: [SearchmaskComponent, TranslateModule, AvailabilityRoom1SkeletonComponent, ButtonModule, ImageGallery1Component, MapComponent, DialogModule],
    templateUrl: './hotels.component.html',
    styleUrl: './hotels.component.scss'
})
export class HotelsComponent implements OnInit, OnDestroy {

  showSearchMask:boolean = false;
  searchParams:ISearchParams|null;
  hotels:IHotelInfo[] = [];
  contactDetails: PIMContactDetailsv2[] = [];
  noAvInSomeIndex:any;
  changeDetected:boolean = false;
  language:string;
  mapDialogVisible:boolean = false; 
  mapCoordinates:number[]|null = null; 

  subs:Subscription[] = [];

  constructor (
    private avService: AvailabilityService, 
    private pimService: PIMService,
    private shopCartService: ShopcartService, 
    public settings: SettingsService, 
    private languageService: LanguageService,
  ) {
    if (this.avService.getSearchParams()) {
      this.searchParams = this.avService.getSearchParams();
    }
  }

  ngOnInit() {
    this.language = this.languageService.getCurrentLanguage();
    this.settings.get('app.endpoints').forEach((epObj:any) => {
      let hotelInfo:IHotelInfo = this.pimService.getHotelInfo(epObj.hotelCode);
      if (hotelInfo) {
        hotelInfo.hotelCode = epObj.hotelCode;
        this.hotels.push(hotelInfo);
      }

      let contactDetails:PIMContactDetailsv2|null = this.pimService.getContactDetails(epObj.hotelCode);
      if (contactDetails) {
        this.contactDetails.push(contactDetails);
      }
    });
  }

  setChangeDetected(value:boolean) {
    this.changeDetected = value;
  }

  selectHotel(hotelCode:string|undefined) {
    if (hotelCode) {
      this.avService.selectHotelAndMakeSearch(hotelCode);
    }
  }

  showMap(latLng:number[]|undefined) {
    if (latLng) {
      this.mapCoordinates = latLng;
      this.mapDialogVisible = true;
    }
    
  }

  closeMap() {
    this.mapCoordinates = null;
    this.mapDialogVisible = false;
  }


  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe())
  }
}
